module.exports = __webpack_public_path__ + "static/img/a1.a3c2485.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a1.png
// module id = NDEQ
// module chunks = 0